/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { PageMetaResolver } from '@lm-nx-frontend/lm-inf-core';
import { OrganizationPageMetaResolver } from './organization-page-meta.resolver';

@NgModule({
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: OrganizationPageMetaResolver,
      multi: true,
    },
  ],
})
export class OrganizationPageMetaModule {}
